import { Component,  h,  Host,  Event,  EventEmitter,  Method,  Prop,  Watch,  State} from "@stencil/core";
import L, { LatLngExpression } from "leaflet";
import * as esri from "esri-leaflet";
import ELG from "esri-leaflet-geocoder";
import fullScreen from "../../js/vendor/Control.FullScreen.js";
import { DEFAULT_ICON_SIZE, DEFAULT_ICON_ANCHOR } from '../../js/constants/map-constants';
const DEFAULT_LOCATION_ICON = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgaGVpZ2h0PSIzMHB4IiB3aWR0aD0iMzBweCI+ICAgIDxwYXRoIGQ9Ik0xOC43IDEzLjhjMi43IDEgNC41IDIuNSA0LjUgNC4yIDAgMi45LTUgNS4yLTExLjIgNS4yUy44IDIwLjkuOCAxOGMwLTEuNyAxLjgtMy4yIDQuNS00LjIiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzNhNzhiYiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgLz4gICAgPHBhdGggZmlsbD0iIzNhNzhiYiIgZD0iTTEyIC43YzEuNCAwIDIuNiAxLjIgMi42IDIuNlMxMy40IDYgMTIgNiA5LjQgNC44IDkuNCAzLjQgMTAuNi43IDEyIC43ek0xNS44IDEyLjd2LTIuMmMwLTIuMS0xLjctMy44LTMuOC0zLjhzLTMuOCAxLjctMy44IDMuOHYyLjJoMS41bC44IDZoM2wuOC02aDEuNXoiIC8+PC9zdmc+";
const DEFAULT_ICON = 'data:image/png;base64,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';
const DEFAULT_SHADOW_ICON = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAQAAAACach9AAACMUlEQVR4Ae3ShY7jQBAE0Aoz/f9/HTMzhg1zrdKUrJbdx+Kd2nD8VNudfsL/Th///dyQN2TH6f3y/BGpC379rV+S+qqetBOxImNQXL8JCAr2V4iMQXHGNJxeCfZXhSRBcQMfvkOWUdtfzlLgAENmZDcmo2TVmt8OSM2eXxBp3DjHSMFutqS7SbmemzBiR+xpKCNUIRkdkkYxhAkyGoBvyQFEJEefwSmmvBfJuJ6aKqKWnAkvGZOaZXTUgFqYULWNSHUckZuR1HIIimUExutRxwzOLROIG4vKmCKQt364mIlhSyzAf1m9lHZHJZrlAOMMztRRiKimp/rpdJDc9Awry5xTZCte7FHtuS8wJgeYGrex28xNTd086Dik7vUMscQOa8y4DoGtCCSkAKlNwpgNtphjrC6MIHUkR6YWxxs6Sc5xqn222mmCRFzIt8lEdKx+ikCtg91qS2WpwVfBelJCiQJwvzixfI9cxZQWgiSJelKnwBElKYtDOb2MFbhmUigbReQBV0Cg4+qMXSxXSyGUn4UbF8l+7qdSGnTC0XLCmahIgUHLhLOhpVCtw4CzYXvLQWQbJNmxoCsOKAxSgBJno75avolkRw8iIAFcsdc02e9iyCd8tHwmeSSoKTowIgvscSGZUOA7PuCN5b2BX9mQM7S0wYhMNU74zgsPBj3HU7wguAfnxxjFQGBE6pwN+GjME9zHY7zGp8wVxMShYX9NXvEWD3HbwJf4giO4CFIQxXScH1/TM+04kkBiAAAAAElFTkSuQmCC';
/* For some reason it will not recognize the webmap package name as a valid package, so we have to import this file manually */
import { webMap } from "../../../node_modules/esri-leaflet-webmap/src/EsriLeafletWebMap";
@Component({
  tag: "lk-cloud-map"
})
export class CloudMap {
  map: L.Map;
  mapElement: HTMLElement;
  searchControl: any;
  errorsWrapper: HTMLElement;

  @State() userLocation: any = {};
  @State() locationMarkers: any = {};

  @Prop() mapId: string;
  @Prop() locations: [];
  @Prop() search: boolean = false;
  @Prop() gps: boolean = false;
  @Prop() fullscreen: boolean = false;
  @Prop() pointToAddress: boolean = false;

  @Event() mapLoaded: EventEmitter;
  @Event() locationFound: EventEmitter;
  @Event() locationError: EventEmitter;

  constructor() {
    (L as any).esri = esri;
    (L as any).Control.Fullscreen = fullScreen;
  }

  @Watch("locations")
  addMarkersToMap(locations: []) {
    this.locationMarkers.clearLayers();
    if (locations) {
      let markersCoordinates = [];
      locations.map(location => {
        let { url, title, text, lat, long, icon } = location;
        let latLng = {
          lat: lat,
          lng: long
        };
        if (!!lat === true && !!long === true) {
          markersCoordinates.push([lat, long]);
        }

        let popupData = url && title && text ? {
          url,
          title,
          text
        } : null;

        this.renderMarker(latLng, popupData, icon);

      });

      return markersCoordinates;
    }
  }

  @Watch("search")
  addSearchField(search: boolean) {
    if (search) {
      let provider = this.addCustomGeoSearchProvider({
        label: "Lillestrøm Kommune adressesøk",
        maxResults: 6,
        url:
          "https://karttjenester.lillestrom.kommune.no/arcgis/rest/services/InnbyggerPortal/GeocodeAdress/GeocodeServer",
        outSR: 4326

      });

      this.addressSearch(
        {
          expanded: true,
          position: "topright",
          placeholder: "Søk etter sted eller adresse",
          title: "Søk etter sted eller adresse",
          autoClose: false,
        },
        provider
      );

      this.searchControl.on("results", data => {
        this.userLocation.clearLayers();
        L.marker(data.latlng, {
          icon: this.defaultIcon("https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png")  // Orange locator icon =>   ("data:image/png;base64,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")
        })
          .addTo(this.userLocation)
          .bindPopup(data.text);

      })

      this.searchControl.on("requestsuccess", data => {
        if (!document.querySelector(".geocoder-control-list") && !data.response.candidate && data.params.text) {
          if (!this.errorsWrapper.classList.contains("visible")) {
            this.errorsWrapper.textContent = "Beklager ingen treff";
            this.errorsWrapper.classList.add("visible")
          }
        } else {
          this.errorsWrapper.textContent = "";
          this.errorsWrapper.classList.remove("visible")
        }
        return data
      });

      this.searchControl.on("requesterror", data => {
        this.errorsWrapper.classList.add("visible")
        return data
      });

      this.searchControl.on("requeststart", () => {
        this.errorsWrapper.classList.remove("visible")
      });


    }
    return;
  }

  @Watch("gps")
  addGps(gps: boolean) {
    if (gps) {
      this.geoLocation();
    }
  }

  @Watch("fullscreen")
  addFullscreen(fullScreen: boolean) {
    if (fullScreen) {
      this.fullScreenMode();
    }
  }

  defaultIcon(iconUrl = null) {
    return L.icon({
      iconUrl: iconUrl ? iconUrl : DEFAULT_ICON,
      iconSize: [20, 33],
      iconAnchor: [10, 33],
      shadowUrl: DEFAULT_SHADOW_ICON,
      shadowSize: [20, 33],
      shadowAnchor: [7, 33],
      popupAnchor: [0, -33]
    });
  }

  /**
   *Search for closest address based on point in map
   *@param latLng Object consisting of latitude and longitude coordinates
   *@returns {result} Object containing information relevant to that point
   */
  pointToAddressSearch = (latLng: any) => {
    ELG.reverseGeocode()
      .latlng(latLng)
      .run((error, result) => {
        if (error) return;
        this.userLocation.clearLayers();
        L.marker(result.latlng, {
          icon: L.icon({
            iconUrl: DEFAULT_LOCATION_ICON,
            iconSize: [20, 33],
            iconAnchor: [10, 33]
          })
        })
          .addTo(this.userLocation)
          .bindPopup(result.address.Match_addr);
      });
  };

  fullScreenMode = () => {
    (L as any).Control
      .fullscreen({
        position: "topleft", // change the position of the button can be topleft, topright, bottomright or bottomleft, defaut topleft
        title: "Vis fullskjerm", // change the title of the button, default Full Screen
        titleCancel: "Lukk fullskjerm", // change the title of the button when fullscreen is on, default Exit Full Screen
        content: null, // change the content of the button, can be HTML, default null
        forceSeparateButton: true, // force seperate button to detach from zoom buttons, default false
        forcePseudoFullscreen: false, // force use of pseudo full screen even if full screen API is available, default false
        fullscreenElement: false // Dom element to render in full screen, false by default, fallback to map._container
      })
      .addTo((this.map as any)._map);
  };

  geoLocation = () => {
    let customControl = L.Control.extend({
      options: {
        position: "topleft"
      },
      onAdd: map => {
        let container = L.DomUtil.create(
          "button",
          "leaflet-bar leaflet-control leaflet-control-custom leaflet-bar-gps"
        );

        container.onclick = e => {
          e.stopPropagation();
          this.userLocation.clearLayers();
          let latlng;
          container.classList.toggle("leaflet-bar-gps--loading")
          navigator.geolocation.getCurrentPosition(location => {
            container.classList.toggle("leaflet-bar-gps--loading")
            latlng = new L.LatLng(
              location.coords.latitude,
              location.coords.longitude
            );
            map.setView(latlng, 15);

            L.marker(latlng, {
              icon: L.icon({
                iconUrl: "https://unpkg.com/leaflet@1.5.1/dist/images/marker-icon.png", //DEFAULT_LOCATION_ICON
                iconSize: [20, 33],
                iconAnchor: [10, 33]
              })
            })
              .addTo(this.userLocation)
          });
        };

        container.setAttribute("title", "finn meg");
        container.setAttribute("type", "button");
        return container;
      }
    });
    (this.map as any)._map.addControl(new customControl());
  };

  renderMarker(latlng: LatLngExpression, popupContent: any, icon: string) {

    let marker = L.marker(latlng, {
      icon: icon ? this.defaultIcon(icon) : this.defaultIcon()
    }).addTo(this.locationMarkers)
    if (popupContent) {
      marker.bindPopup(this.generatePopupContentWrapper(popupContent));
    }
  }

  generatePopupContentWrapper(popupData: any) {
    return `<div>
        <h1>
          <a href=${popupData.url}>${popupData.title}</a>
        </h1>
        <p>${popupData.text}</p>
      </div>`;
  }

  /**
   *Creates a instance of a custom search provider to be included into search field
   *@param url URL to custom geosearch provider
   *@param config An optional configuration object
   *@returns {result} Object containing information relevant to that point
   */
  addCustomGeoSearchProvider(config: any = {}, url?: string) {
    let conf = config;
    if (!conf.hasOwnProperty("url")) {
      conf.url = url;
    }
    return new ELG.GeocodeServiceProvider(conf)

  }

  /**
   * Adds searchability to the map 
   * @param config An optional configuration object
   * @param provider an instance of a custom search provider
   */
  @Method()
  async addressSearch(config: any = {}, provider?: any) {
    let conf = config;
    if (!conf.hasOwnProperty("providers")) {
      conf.providers = [provider];
    }

    conf.useMapBounds = false;
    conf.collapseAfterResult = false;
    conf.expanded = true;
    this.searchControl = new ELG.Geosearch(conf).addTo((this.map as any)._map);

    this.searchControl._wrapper.style.marginBottom = "10px";
    this.errorsWrapper = document.querySelector(".geocoder-control").insertBefore(document.createElement("div"), document.querySelector(".geocoder-control-suggestions"))
    this.errorsWrapper.classList.add("geocoder-control-errors");
  }

  /* Once the component has loaded, set up the map itself */
  componentDidLoad() {

    if (!this.mapId) {
      throw new Error("Fatal: The map-id parameter was not specified!");
    }

    /* Set default icon URL, anchor and size */
    L.Icon.Default.prototype.options = {
      iconUrl: DEFAULT_ICON,
      iconAnchor: DEFAULT_ICON_ANCHOR,
      iconSize: DEFAULT_ICON_SIZE
    };

    this.map = webMap(this.mapId, { map: L.map("cloudmap", { zoomControl: false, scrollWheelZoom: false, keyboard: false }) });
    L.control.zoom({
      zoomInTitle: "zoom inn",
      zoomOutTitle: "zoom ut",
      position: "topleft"
    }).addTo((this.map as any)._map);

    // Generelt bakgrunnskart / Nederst på kartet venstre side 
    this.map.on("load", () => {
      var overlayMaps = {};
      (this.map as any).layers.map(l => {
        overlayMaps[l.title] = l.layer;
      });
      L.control
        .layers({}, overlayMaps, {
          position: "bottomleft"
        })
        .addTo((this.map as any)._map);
      console.log("markersCoordinates", markersCoordinates)
      if (markersCoordinates) {
        (this.map as any)._map.fitBounds(markersCoordinates, { padding: [100, 100] });
      }

    });

    /* Event emitters */

    this.map.on("locationfound", event => {
      this.locationFound.emit(event);
    });

    this.map.on("locationerror", event => {
      this.locationError.emit(event);
    });

    if (this.pointToAddress) {
      (this.map as any)._map.on("click", event => {
        this.pointToAddressSearch(event.latlng);
        (this.map as any)._map.scrollWheelZoom.enable();
      });
    }

    this.userLocation = L.layerGroup().addTo((this.map as any)._map);
    this.locationMarkers = L.layerGroup().addTo((this.map as any)._map);
    this.addSearchField(this.search);
    //this.addFullscreen(this.fullscreen);
    this.addGps(this.gps);
    let markersCoordinates = this.addMarkersToMap(this.locations);
    this.mapLoaded.emit();
  }

  /* Render the base markup for the component */
  render() {
    return (
      <Host class="map">
        <div
          class="map__container"
          ref={el => (this.mapElement = el)}
          id="cloudmap"
          role="application" 
          tabindex="0" 
          aria-label="Kart"
        ></div>
      </Host>
    );
  }
}
